/*global commune*/
var ajaxRootUri = "";
var ajaxTargetPid = 0;
angular.module('List').factory('DataService', [
  '$http',
  '$q',
  function ($http, $q) {
    'use strict';
    return {
      indicatorList: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorListJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function (data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorList', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      categoryList: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'CategoryListJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function (data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorCategoryList', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      indicatorTypeList: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTypeListJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorTypeList', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      indicatorTree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTreeJson',
              'actionName': 'list',
              'arguments[commune]': commune ? commune : 0,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            // set Cache
            localStorage.setItem('hyperionIndicatorTree', JSON.stringify(data));
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      setHidden: function (type, uid, action) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTreeJson',
              'actionName': action,
              'arguments[type]': type,
              'arguments[uid]': uid,
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            console.info(data);
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      moveItem: function(source, dest, next, prev, itemsNeedToUpdate) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorTreeJson',
              'actionName': 'moveItem',
              'arguments[source][uid]': source.uid,
              'arguments[source][parent]': source.parent,
              'arguments[source][type]': source.class,
              'arguments[dest][uid]': dest ? dest.uid : 0,
              'arguments[dest][parent]': dest ? dest.parent : 0,
              'arguments[next][uid]': next ? next.uid : 0,
              'arguments[next][type]': next ? next.class : 0,
              'arguments[next][sorting]': next ? next.sorting : 0,
              'arguments[prev][uid]': prev ? prev.uid : 0,
              'arguments[prev][type]': prev ? prev.class : 0,
              'arguments[prev][sorting]': prev ? prev.sorting : 0,
              'arguments[itemsNeedToUpdate]': JSON.stringify(itemsNeedToUpdate),
              'arguments[listsPid]': listsPid ? listsPid : 0
            }
          }).success(function(data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      }
    };
  }
]);
